"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviourExecution = void 0;
/**
 * Represents behaviour execution information
 */
var BehaviourExecution = /** @class */ (function (_super) {
    __extends(BehaviourExecution, _super);
    function BehaviourExecution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "BehaviourExecution";
        _this.processInstanceId = function () {
            _this.push(function (_) { return "processInstanceId"; });
        };
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        _this.state = function () {
            _this.push(function (_) { return "state"; });
        };
        _this.name = function () {
            _this.push(function (_) { return "name"; });
        };
        _this.duration = function () {
            _this.push(function (_) { return "duration"; });
        };
        _this.behaviourId = function () {
            _this.push(function (_) { return "behaviourId"; });
        };
        _this.created = function () {
            _this.push(function (_) { return "created"; });
        };
        _this.updated = function () {
            _this.push(function (_) { return "updated"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return BehaviourExecution;
}(Array));
exports.BehaviourExecution = BehaviourExecution;
//# sourceMappingURL=BehaviourExecution.js.map